module.exports = __webpack_public_path__ + "client/img/space_bg.bfdcafc5.png";